<template>
  <main class="c-layoutMypage">
    <div class="c-sub">
      <mypage-profile :auth="$store.state.auth" />
      <mypage-menu :current="current" />
    </div>
    <div id="c-main" class="c-main">
      <slot />
    </div>
  </main>
</template>

<script>
import MypageProfile from '~/components/organisms/MypageProfile'
import MypageMenu from '~/components/organisms/MypageMenu'

import { mapGetters } from 'vuex'

export default {
  name: 'layoutMypage',
  props: {
    current: {
      type: String,
      default: 'home'
    }
  },
  components: {
    MypageProfile,
    MypageMenu
  },
  computed: {
    ...mapGetters('auth', ['isFromCoconalaApp', 'isLoggedIn'])
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: breakpoint(Mypage, L) + 1) {
  .c-layoutMypage {
    width: 1024px;
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
  }

  .c-sub {
    width: 232px;
    min-width: 232px;
    padding: 0 12px;
    margin-right: 24px;
    box-sizing: content-box;
  }

  .c-main {
    flex-grow: 1;
    min-width: 0;
  }
}

@media (max-width: breakpoint(Mypage, L)) {
  .c-sub {
    display: none;
  }
  .c-main {
    width: 100%;
  }
}
</style>
